import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizeMessage } from 'libs.nucleus';
import { Skeleton } from '../../skeleton_loader';
const SummaryDisplay = ({ piOversightSummary, isLoading, }) => {
    const translate = useLocalizeMessage();
    let nodeToRender;
    if (isLoading) {
        nodeToRender = (_jsxs(_Fragment, { children: [_jsx(Skeleton, { component: 'Text', className: 'w-full mb-1', innerClassName: 'h-5' }), _jsx(Skeleton, { component: 'Text', className: 'w-full mb-1', innerClassName: 'h-5' }), _jsx(Skeleton, { component: 'Text', className: 'w-2/3', innerClassName: 'h-5' })] }));
    }
    else if (piOversightSummary?.summary) {
        nodeToRender = (_jsx("p", { className: 'text-sm leading-relaxed', "data-testid": 'pi-oversight-summary-text', children: piOversightSummary.summary }));
    }
    else {
        nodeToRender = (_jsx("div", { className: 'mt-4 p-4 bg-gray-50 border-l-4 border-gray-400 rounded-md', children: _jsx("p", { className: 'text-sm leading-relaxed', "data-testid": 'pi-oversight-summary-text', children: translate('info.pi_oversight.no_summary_generated') }) }));
    }
    return nodeToRender;
};
export default SummaryDisplay;
